import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/cope_up_img.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="border_subtitle">Review and identify</div>
                                            <p>
                                                In what context are you working at the moment? It could be that
                                                you’re in a new job, or have a
                                                new team or a difficult team member to manage. Even if the
                                                situation is subject to influences
                                                beyond your control, it’s important to maintain communication
                                                with those you work with and for
                                                – and don’t be afraid to ask for help. You need to be aware of
                                                possible political or cultural
                                                influences which may determine the success or otherwise of your
                                                plan as well as the kind of
                                                setbacks which may occur.
                                            </p>
                                            <p>
                                                Identify any other external or personal ‘stressors’ that could
                                                affect your ability to achieve your
                                                goal. Going through a divorce, bereavement, illness or even
                                                moving house can themselves be
                                                setbacks. Reviewing circumstances as well as specifics will
                                                produce an overall perspective and
                                                banish needless self reproach. It will clarify your objectives
                                                and what needs to be altered to
                                                achieve them.
                                            </p>
                                            <div className="border_subtitle">Thinking and redefining success
                                            </div>
                                            <p>
                                                What does success look like to you? Is this setback such a
                                                critical issue? If your strategy didn’t
                                                work first time, think of how you could make it more flexible
                                                rather than giving up altogether. Or,
                                                what would the consequences of getting that new job have been
                                                for your family? A coveted
                                                promotion may have meant less time with them.
                                            </p>
                                            <p>
                                                Flexibility offers more options than rigid attachment to a
                                                particular outcome – there is usually
                                                more than one way to achieve anything. Achieving goals is not
                                                always a linear process and
                                                flexibility often overcomes the bleakest outlook, as this
                                                account of the building of Brooklyn
                                                Bridge proves:
                                            </p>
                                            <div className="lightgreencontentbg  uiheading greennumberroundbg1">
                                                <p>
                                                    The Brooklyn Bridge spans the East River between Manhattan
                                                    and Brooklyn. Several
                                                    setbacks occurred during its construction, but the worst
                                                    involved its suspension cables.
                                                    Over six months or so, a crooked contractor delivered more
                                                    than 200 tons of defective
                                                    steel cables which had already been installed by the time
                                                    the fraud was discovered. They
                                                    couldn’t be removed because, as the bridge engineer
                                                    calculated, this would have weakened
                                                    the cables from the required margin of ‘six times maximum
                                                    required strength’ to only ‘five
                                                    times maximum strength’. He finally solved the problem by
                                                    adding an additional 150 wires
                                                    to each cable, and they remain in place to this day! The
                                                    contractor involved had succeeded
                                                    in his deception by replacing cables of an acceptable
                                                    standard with substandard ones
                                                    between inspection and delivery. At the time, the public was
                                                    unaware of what had happened,
                                                    and the contractor’s only penalty was to pay for all the
                                                    additional wires used.
                                                </p>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}